import { gql } from '@apollo/client'

export const AbortMultipartUpload = gql`
    mutation AbortMultipartUpload($uploadId: ID!, $hash: String!) {
        abortMultipartUpload(uploadId: $uploadId, hash: $hash)
    }
`

export default AbortMultipartUpload
